var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#15121D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 13.1253L22.5402 16.6015C26.8466 13.2095 26.8466 9.55475 26.8466 9.55475L21.1323 15.1093C24.9783 8.82716 23.5704 6.24023 23.5704 6.24023L19.0188 13.8091C18.0204 13.5379 16.9913 13.4009 15.9579 13.4015H15.8851C14.8516 13.4009 13.8226 13.5379 12.8242 13.8091L8.27258 6.24023C8.27258 6.24023 6.67919 8.61496 10.5252 14.897L5.0063 9.55475C5.0063 9.55475 4.44314 12.8019 9.0444 16.3994C9.02121 16.4365 3.84024 13.1253 3.84024 13.1253C3.84024 13.1253 3.70773 16.2444 8.27258 18.7472V18.828C8.27258 22.22 11.6747 25.7232 15.8917 25.7602H15.9646C20.175 25.7232 23.5837 22.22 23.5837 18.828V18.7472C28.132 16.2444 27.9994 13.1253 27.9994 13.1253ZM13.3443 22.2368C13.3443 22.2368 11.9927 22.3244 11.2142 21.5329C10.4357 20.7413 10.5318 19.3703 10.5318 19.3703C10.5318 19.3703 11.8834 19.2794 12.6618 20.0743C13.4403 20.8693 13.3443 22.2368 13.3443 22.2368ZM20.6321 21.5329C19.8536 22.3244 18.5054 22.2368 18.5054 22.2368C18.5054 22.2368 18.4192 20.8659 19.1977 20.0743C19.9762 19.2827 21.3244 19.3703 21.3244 19.3703C21.3244 19.3703 21.4006 20.7413 20.6188 21.5329H20.6321Z",
    fill: "url(#paint0_linear_89918_87980)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89918_87980",
    x1: 9.061,
    y1: 21.2331,
    x2: 23.5288,
    y2: 5.37889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB23C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlot);
export default __webpack_public_path__ + "static/media/alot.fda72ab937e294a8e6d6ec86670702be.svg";
export { ForwardRef as ReactComponent };